module.exports = __webpack_public_path__ + "static/media/event_result.8c7a5114.jpg";